import WebshopReceipt from './WebshopReceipt'

export default WebshopReceipt
